import { render } from "./BranchViewer.vue?vue&type=template&id=51d6d014&scoped=true&ts=true"
import script from "./BranchViewer.vue?vue&type=script&lang=ts"
export * from "./BranchViewer.vue?vue&type=script&lang=ts"

import "./BranchViewer.vue?vue&type=style&index=0&id=51d6d014&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d6d014"]])

export default __exports__